import { render, staticRenderFns } from "./PickList.vue?vue&type=template&id=37bf9551"
import script from "./PickList.vue?vue&type=script&lang=js"
export * from "./PickList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports